import { getModelVersionENVForProject } from '@/domain/impact/utils/get-model-version-for-project';
import { runImpactCalculateFestivalEnvForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-env-for-project.action';
import { runImpactCalculateTourEnvForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-env-for-project.action';
import { runImpactCalculateVenueEnvForProject } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-env-for-project.action.ts';
import { getImpactEnvResponses } from '@/domain/impact-env/actions/get-impact-env-responses.action';
import { EnvQuestionValue } from '@/domain/impact-env/entities/question.entity';
import {
  selectCurrentProject,
  selectCurrentProjectMode,
} from '@/domain/project/project.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { selectImpactEnvResponses } from '../impact-env.selectors';

type Params = {
  projectId: number;
  response: EnvQuestionValue;
};

export const submitImpactEnvResponse = createAppAsyncThunk(
  'impactEnv/submitImpactEnvResponse',
  async (
    { projectId, response }: Params,
    { extra: { impactEnvGateway, snackbarGateway }, dispatch, getState },
  ) => {
    try {
      const { submitMode, answerIdToEdit } = defineSubmitMode(
        selectImpactEnvResponses(getState()),
        response,
      );
      const currentProject = selectCurrentProject(getState());
      const projectMode = selectCurrentProjectMode(getState());
      const modelVersion = getModelVersionENVForProject(
        projectMode,
        currentProject,
      );
      switch (submitMode) {
        case 'create':
          await impactEnvGateway.createImpactEnvResponse(
            projectId,
            response.paramId,
            response.value,
            modelVersion,
          );
          break;
        case 'edit':
          await impactEnvGateway.editImpactEnvResponse(
            answerIdToEdit,
            response.value,
          );
          break;
      }
      dispatch(getImpactEnvResponses({ projectId }));
      if (projectMode === 'festival') {
        dispatch(runImpactCalculateFestivalEnvForProject({ projectId }));
      }
      if (projectMode === 'venue') {
        dispatch(runImpactCalculateVenueEnvForProject({ projectId }));
      }
      if (projectMode === 'tour') {
        dispatch(runImpactCalculateTourEnvForProject({ projectId }));
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function defineSubmitMode(
  responses: EnvQuestionValue[],
  answerToSubmit: EnvQuestionValue,
): { submitMode: 'create' | 'edit'; answerIdToEdit: number } {
  const item = responses.find((x) => x.paramId === answerToSubmit.paramId);
  if (item) {
    return { submitMode: 'edit', answerIdToEdit: item.id };
  } else {
    return { submitMode: 'create', answerIdToEdit: -1 };
  }
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('SubmitImpactAnswer.Message.error'));
}
